import type { ProjectCarouselEntry } from "../../../data/projects";
import type { ViewportTier } from "../../../lib/viewport";
import { isMobileViewport } from "../../../lib/viewport";
import { ProjectCard3D } from "./ProjectCard3D";

type ProjectCarousel3DProps = {
  compact: boolean;
  projects: ProjectCarouselEntry[];
  rotationProgress: number;
  viewport: ViewportTier;
  weight: number;
};

export function ProjectCarousel3D({ compact, projects, rotationProgress, viewport, weight }: ProjectCarousel3DProps) {
  const mobile = isMobileViewport(viewport);

  return (
    <group
      position={mobile ? [0, 0.5, 1.72] : [1.62, compact ? -0.04 : -0.1, compact ? -0.86 : -1.16]}
      scale={mobile ? 0.98 : 1}
    >
      {projects.map((project, index) => (
        <ProjectCard3D
          compact={compact}
          index={index}
          key={project.slug}
          project={project}
          rotationProgress={rotationProgress}
          viewport={viewport}
          weight={weight}
        />
      ))}
    </group>
  );
}
